import TraderPmgClosedSalesList from '../../../trader/PMG/SalesList/TraderPmgClosedSalesList'

export const SalesmanPmgClosedSalesList = TraderPmgClosedSalesList

export default SalesmanPmgClosedSalesList
